import type { Feature, FeatureCollection, Polygon } from 'geojson'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapSingle } from '../normalize'

export type VectorizeGeorasterParams = {
  file: File
  name: string
  perimeter: Feature<Polygon>
  area: number
  threshold: number
  signal?: AbortSignal
}

export default async function vectorizeGeoraster({
  file,
  name,
  perimeter,
  area,
  threshold,
  signal,
}: VectorizeGeorasterParams): Promise<FeatureCollection> {
  const formData = new FormData()
  formData.append('file', file, name)
  formData.append('perimeter', JSON.stringify({ type: 'FeatureCollection', features: [perimeter] }))
  formData.append('area', String(area))
  formData.append('threshold', String(threshold))

  const response = await apiClient.post(endpoints.stratification.vectorize, formData, { signal })
  return unwrapSingle<FeatureCollection>(response)
}
